import * as React from "react";
import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import FormControl from "@mui/material/FormControl";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import {
  Button,
  Typography,
  Checkbox,
  FormGroup,
  TextField,
  Divider,
  Box,
  FormHelperText,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import DateObject from "react-date-object";
import gregorian from "react-date-object/calendars/gregorian";
import { myWordsQuery } from "../../../../../../validations/myWordsValidation";
import {
  incomesCalculationApi,
  requestCheckoutApi,
} from "../../../../../../services/accountingApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DialogData from "./DialogData";
import GetBankAccounts from "./GetBankAccounts";
import { checkResponseData, checkErrorMessage } from "../../../../utils/utilsFunctions"


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function NewCheckouts(props) {
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [openDialogContent, setOpenDialogContent] = React.useState(false);
  const [dialogTitle, setDialogTitle] = React.useState("");
  const [dialogContentData, setDialogContentData] = React.useState("");
  const [newCheckout, setNewCheckout] = React.useState({
    bankCheckoutInfo: "",
    bankCheckoutCardNumber: "",
    bankCardStatus: false,
    bankName: "",
    userDescription: "",
  });
  const [totalIncomes, setTotalIncomes] = React.useState("");
  const handleCloseDialogContent = () => {
    setOpenDialogContent(false);
  };

  const handleSetValue = (key, value) => {
    const newValue = {};
    newValue[key] = value;
    setNewCheckout({ ...newCheckout, ...newValue });
  };

  const handleSetBankInfo = (data) => {
    // propsFiled.setFieldValue("bankName", e.target.value);
    setNewCheckout({ ...newCheckout, ...data });
  };

  const incomeCalculation = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const calculate = await incomesCalculationApi({})
      console.log("asddasd4a6s5d4a6sd46as", calculate)
      const resData = checkResponseData(calculate);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
      setTotalIncomes(calculate["data"]["data"]["data"][0]["amountIncomes"]);
    } catch (error) {

      // let errMsg=errData["titles"] || errData["message"]
      // toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false,autoClose:3000 });
      console.error("requestCheckoutToBack", error);
      const errData = checkErrorMessage(error);

      let errMsg = errData["titles"] || errData["message"]
      console.error("requestCheckoutToBackerrMsgerrMsg", errMsg);
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 6000 });
      setTotalIncomes("");
    }
  };
  const initialValues = {
    bankCheckoutInfo: "",
    bankName: "",
    userDescription: "",
  };

  const customToastify = (type, message) => {
    const options = {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    };

    if (type == "info") {
      toast.info(message, options);
      // console.log("type,message", type, message);
    }
    if (type == "success") toast.success(message, options);
    if (type == "warning") toast.warning(message, options);
    if (type == "error") toast.error(message, options);
  };

  const requestCheckoutToBack = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")

    try {
      // console.log("amirdata", data);

      const newRequest = await requestCheckoutApi(data)
      const resData = checkResponseData(newRequest);
      if (resData["success"]) toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: true, autoClose: 3000 });
      else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: true, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  const onSubmit = (values, props) => {
    if (totalIncomes < 3000000) {
      customToastify(
        "error",
        "ابتدا بر روی محاسبه درآمد کلیک کرده و  حداقل درآمد قابل تسویه 300 هزار تومان می باشد"
      );
    } else if (newCheckout.bankCardStatus !== true) {
      customToastify("error", "لطفا یک کارت بانکی فعال را انتخاب کنید");
    } else {
      let newValues = {
        bankCheckoutInfo: newCheckout["bankCheckoutInfo"],
        bankName: values.bankName || newCheckout["bankName"],
        userDescription: values.userDescription,
      };

      for (const property in newValues) {
        if (typeof newValues[property] == "boolean") continue;
        if (!newValues[property]) delete newValues[property];
      }
      // console.log("amir", newValues);
      requestCheckoutToBack(newValues);
    }
  };

  const handleOpenDialogContent = () => {
    setOpenDialogContent(true);
  };

  const setDialog = (type) => {
    if (type == "selectBank") {
      setDialogTitle(`انتخاب حساب برای واریز وجه`);
      handleOpenDialogContent();
      setDialogContentData(
        <GetBankAccounts
          handleSetBankInfo={handleSetBankInfo}
          handleCloseDialogContent={handleCloseDialogContent}
        />
      );
    }
  };

  return (
    <Box>
      <DialogData
        openDialogContent={openDialogContent}
        handleCloseDialogContent={handleCloseDialogContent}
        dialogTitle={dialogTitle}
      >
        {dialogContentData}
      </DialogData>

      <Box
        sx={{
          display: "inline-flex",
          flexDirection: "row",
          alignItems: "center",
          m: 2,
        }}
      >
        <Button variant="contained" color="info" onClick={incomeCalculation}>
          محاسبه درآمد
        </Button>
        <Typography sx={{ mx: 2 }}>{`${totalIncomes} ریال`}</Typography>
      </Box>
      <Formik
        initialValues={initialValues}
        validationSchema={myWordsQuery}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "25%" : "50%" }}
                    ></StyledTableCell>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "75%" : "50%" }}
                    >
                      {" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"بانک و حساب"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormControl
                        style={{
                          display: "inline-flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          onClick={() => setDialog("selectBank")}
                        >
                          انتخاب حساب
                        </Button>
                        <Typography sx={{ mx: 1 }}>
                          {`${newCheckout["bankCheckoutCardNumber"].slice(
                            newCheckout["bankCheckoutCardNumber"].length - 6,
                            newCheckout["bankCheckoutCardNumber"].length
                          )} ...`}
                        </Typography>
                      </FormControl>
                      <FormHelperText
                        sx={{ color: "#f96767", textAlign: "center" }}
                      >
                        <ErrorMessage name="bankCheckoutInfo" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"نام بانک"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="bankName"
                        label="نام بانک"
                        placeholder="نام بانک"
                        value={newCheckout.bankName}
                        onChange={(e) => {
                          props.setFieldValue("bankName", e.target.value);
                          handleSetValue("bankName", e.target.value);
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="bankName" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"توضیحات"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <Field
                        type="text"
                        size="small"
                        as={TextField}
                        name="userDescription"
                        multiline
                        inputProps={{ maxLength: 300 }}
                        label="توضیحات"
                        placeholder="توضیحات"
                        value={newCheckout.userDescription}
                        onChange={(e) => {
                          props.setFieldValue(
                            "userDescription",
                            e.target.value
                          );
                          handleSetValue("userDescription", e.target.value);
                        }}
                      />
                      <FormHelperText
                        sx={{
                          m: 0,
                          p: 0,
                          color: "#f96767",
                          textAlign: "center",
                        }}
                      >
                        <ErrorMessage name="userDescription" />
                      </FormHelperText>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 2 }}
              color="success"
            >
              ثبت درخواست
            </Button>
          </Form>
        )}
      </Formik>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </Box>
  );
}
